export default {
  // common
  ok: 'موافق',
  cancel: 'إلغاء',
  send: 'إرسال',
  // time
  timeJustNow: 'الآن',
  timeMinutesAgo: 'قبل {n} دقيقة',
  timeHoursAgo: 'قبل {n} ساعة',
  timeYesterday: 'أمس',
  // chat toolbar titles
  chatEmotion: 'رمز تعبيري',
  chatSendImage: 'إرسال صورة',
  chatSendFile: 'إرسال ملف',
  chatReceipt: 'رسالة إيصال',
  chatSendVoice: 'إرسال صوت',
  chatGroupInfo: 'معلومات المجموعة',
  // chat area
  chatSomeoneAtMe: 'شخص ما أشار إليّ',
  chatNewMessages: '{n} رسائل جديدة',
  chatBackToBottom: 'العودة إلى الأسفل',
  chatReceiptPrefix: '[إيصال] ',
  // message actions / tips
  chatNoMoreMessages: 'لا مزيد من الرسائل',
  chatDeleteConfirm: 'حذف هذه الرسالة؟',
  chatDeleteTitle: 'حذف الرسالة',
  chatRecallConfirm: 'سحب هذه الرسالة؟',
  chatRecallTitle: 'سحب الرسالة',
  chatRecalled: 'تم سحب الرسالة',
  chatLocateFail: 'تعذر العثور على الرسالة الأصلية',
  chatResendUnsupported: 'هذه الرسالة لا تدعم إعادة الإرسال التلقائي. يرجى إعادة الإرسال يدويًا.',
  // input disabled tips
  chatGroupDissolved: 'تم حل المجموعة',
  chatGroupQuit: 'لم تعد عضوًا في هذه المجموعة',
  chatGroupBanned: 'تم حظر المجموعة',
  chatUserBanned: 'تم حظر هذا الحساب',
  chatBanReason: '، السبب: ',
  // message status / readed
  msgReaded: 'مقروءة',
  msgUnread: 'غير مقروءة',
  msgAllReaded: 'قُرئت من الجميع',
  msgSomeReaded: 'قُرئت من {n}',
  msgSending: 'جارٍ الإرسال',
  msgSendFail: 'فشل الإرسال',
  msgRecall: 'إعادة الاتصال',
  msgMenuDelete: 'حذف',
  msgMenuRecall: 'سحب',
  // voice record
  recordTitle: 'تسجيل صوتي',
  recordDuration: 'المدة',
  recordStart: 'بدء',
  recordPause: 'إيقاف مؤقت',
  recordResume: 'استئناف',
  recordStop: 'إيقاف',
  recordPlay: 'تشغيل',
  recordStopPlay: 'إيقاف التشغيل',
  recordRestart: 'إعادة التسجيل',
  recordSend: 'إرسال الآن',
  recordStateReady: 'لم يبدأ',
  recordStateRunning: 'جارٍ التسجيل...',
  recordStatePaused: 'التسجيل متوقف مؤقتًا',
  recordStateStopped: 'توقف التسجيل',
  msgReadedTab: 'مقروءة ({n})',
  msgUnreadTab: 'غير مقروءة ({n})',
  // language
  langLabel: 'اللغة',
  langZh: '中文',
  langEn: 'English'
}
